export const COMPANY = {
  name: "EL-Gas and Plumbing",
  shortName: "EL-Gas",
  phone: "07930 657151",
  phoneTel: "+447930657151",
  email: "el.gas.nplumbing@gmail.com",
  address: "Median Rd, Lower Clapton, London E5 0PL",
  area: "Lower Clapton, Hackney, Islington & E5",
  rating: 5.0,
  reviewCount: 80,
  gasSafeNumber: "604161",
  hours: [
    { day: "Monday – Friday", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 6:30 PM" },
    { day: "Sunday", time: "Closed" },
    { day: "Emergency Line", time: "Call for availability" },
  ],
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Landlord Certificates", to: "/landlord-certificates" },
  { label: "Booking", to: "/booking" },
  { label: "Contact Us", to: "/contact" },
];

export const SERVICE_OPTIONS = [
  {
    value: "boiler-service",
    label: "Boiler Service",
    description: "Annual servicing & efficiency check",
  },
  {
    value: "emergency-repair",
    label: "Emergency Repair",
    description: "Burst pipes, leaks, boiler breakdowns",
  },
  {
    value: "landlord-check",
    label: "Landlord CP12 Check",
    description: "Official gas safety certificate",
  },
  {
    value: "general-quote",
    label: "General Quote",
    description: "Installations & quotation requests",
  },
];

export const TIME_WINDOWS = [
  { value: "morning", label: "Morning", range: "9:00 AM – 1:00 PM" },
  { value: "afternoon", label: "Afternoon", range: "1:00 PM – 6:00 PM" },
];
